var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-component',{attrs:{"options":_vm.options,"id":_vm.id,"name":_vm.name,"value":_vm.search},on:{"addSelectOption":_vm.onAddSelectOption}})
}
var staticRenderFns = []

export { render, staticRenderFns }